import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';

export default function OrgActions({
	id,
	setCurrentEditUserID,
	onOpenUserModal,
	onFindUserToEdit,
	setUserModalType,
	onOpenDeleteUserModal,
}) {
	return (
		<Grid className="flex flex-row justify-evenly">
			<IconButton
				onClick={() => {
					setCurrentEditUserID(id)
					setUserModalType('edit')
					onOpenUserModal()
				}}>
				<Edit />
			</IconButton>
			<IconButton
				onClick={() => {
					setCurrentEditUserID(id)
					onOpenDeleteUserModal()
				}}>
				<Delete />
			</IconButton>
		</Grid>
	)
}
